import React from "react";
import { IZTryWithAiInputProps } from "./interface";
import { ZInput } from "@molecules";
import { ZButton } from "@atoms";
import { EInputWidths } from "@molecules/ZInput/interface";
import GenerateStars from "./generateStars.svg";

const ZTryWithAiInput: React.FC<IZTryWithAiInputProps> = ({
	onCancel,
	inputValue,
	onInputChange,
	onGenerateFormula
}) => {
	return (
		<div className="flex items-center">
			<div className="z-try-with-ai-input flex-1">
				<div className="flex flex-1">
					<ZInput
						value={inputValue}
						onChange={e => onInputChange(e.target.value)}
						onPressEnter={onGenerateFormula}
						placeholder="Write a formula to..."
						width={EInputWidths.full}
						className="flex-1 border-none hover:border-none"
					/>
					<ZButton
						onClick={onGenerateFormula}
						className="generate-btn relative"
						type="text"
					>
						Generate
						<GenerateStars className="absolute right-0 top-1" />
					</ZButton>
				</div>
			</div>
			<ZButton
				size="small"
				className="text-gray-8"
				type="text"
				onClick={onCancel}
			>
				Cancel
			</ZButton>
		</div>
	);
};

export default ZTryWithAiInput;
